import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './NewtonsCradle.scss';
const NewtonsCradle = ({ size = 78, color = 'black', speed = 1.4, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsxs("div", { className: styles.inner, children: [_jsx("div", { className: styles.dot }), _jsx("div", { className: styles.dot }), _jsx("div", { className: styles.dot }), _jsx("div", { className: styles.dot })] }) }));
};
export default NewtonsCradle;
